import type { GameState, InventoryItem } from '../contract.js';
import { RESOURCE_STACK_LIMIT, type ResourceId } from '../domain/content.js';

export function resourceCapacity(slots: Array<InventoryItem | null>, resource: ResourceId): number {
  let capacity = 0;
  for (const slot of slots) {
    if (slot === null) capacity += RESOURCE_STACK_LIMIT;
    else if (slot.kind === 'resource' && slot.resource === resource) capacity += Math.max(0, RESOURCE_STACK_LIMIT - slot.quantity);
  }
  return capacity;
}

export function hasResourceCapacity(slots: Array<InventoryItem | null>, resource: ResourceId, amount = 1): boolean {
  return resourceCapacity(slots, resource) >= amount;
}

export function addResourceToSlotArray(state: GameState, slots: Array<InventoryItem | null>, resource: ResourceId, amount: number): boolean {
  if (amount <= 0) return true;
  if (!hasResourceCapacity(slots, resource, amount)) return false;
  let remaining = amount;
  for (const slot of slots) {
    if (slot?.kind !== 'resource' || slot.resource !== resource || slot.quantity >= RESOURCE_STACK_LIMIT) continue;
    const added = Math.min(RESOURCE_STACK_LIMIT - slot.quantity, remaining);
    slot.quantity += added;
    remaining -= added;
    if (remaining <= 0) return true;
  }
  while (remaining > 0) {
    const slot = slots.findIndex((candidate) => candidate === null);
    if (slot < 0) return false;
    const quantity = Math.min(RESOURCE_STACK_LIMIT, remaining);
    slots[slot] = {
      uid: state.inventory.nextItemUid++,
      kind: 'resource',
      itemId: resource,
      resource,
      quantity,
    };
    remaining -= quantity;
  }
  return true;
}
